// Employee access blocking constants

export const EMPLOYEE_LOGIN_PROVIDER_UID = "00000000-0000-0000-0000-000000000000";

export const BLOCKED_ORGS = ["heliosgesundheit", "coupang"];
export const BACKOFFICE_URL = "https://claroty.com/";

export const getOrgFromUrl = () => window.location.hostname.split(".")[0];

export const isBlockedOrg = () => BLOCKED_ORGS.includes(getOrgFromUrl());
